import React from "react";
import "./styles/footer.css";
import avatar from "../img/Avatar.png";
import whatsapp from "../img/zap.svg";
import instagram from "../img/insta.svg";
import facebook from "../img/face.svg";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    {/* Avatar e Info */}
                    <div className="footer-info">
                        <div className="footer-avatar">
                            <img src={avatar} alt="Precise Preps Avatar" />
                        </div>
                        <h2 className="footer-title">Precise Preps</h2>
                        <p className="footer-location">
                            Located in Florida, USA
                        </p>
                        <p className="footer-phone">Contact: (407) 693-2200</p>
                    </div>

                    {/* Redes Sociais */}
                    <div className="footer-social">
                        <a
                            href="https://wa.me/14076932200"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="WhatsApp"
                        >
                            <img src={whatsapp} alt="WhatsApp" />
                        </a>
                        <a
                            href="https://www.instagram.com/preciseprep"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="Instagram"
                        >
                            <img src={instagram} alt="Instagram" />
                        </a>
                        <a
                            href="https://www.facebook.com/profile.php?id=61585248343524&mibextid=wwXIfr&rdid=Ts86agQvUJlI8a61&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Bs7BoxNio%2F%3Fmibextid%3DwwXIfr#"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link"
                            aria-label="Facebook"
                        >
                            <img src={facebook} alt="Facebook" />
                        </a>
                    </div>
                </div>

                {/* Copyright */}
                <div className="footer-bottom">
                    <p>
                        &copy; {new Date().getFullYear()} Precise Preps. All
                        rights reserved. -
                    </p>
                    <a href="https://www.linkedin.com/in/jo%C3%A3o-rafael-soriano-correia-3106351a1">
                        Developed by João Soriano.
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
